module.exports = __webpack_public_path__ + "static/media/1638203339020_1638464207320.3bcbc784.jpeg";